<template>
  <v-container fluid class="webConNew-management mt-4 px-1">
    <v-row>

      <template>
        <v-row justify="center">
          <v-dialog
              v-model="dialog_upload"
              width="1250px"
          >
            <v-card>

              <UploadManagement
                  id="Conpage_UploadManagement">

              </UploadManagement>

            </v-card>


          </v-dialog>
        </v-row>
      </template>


      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการข่าวประชาสัมพันธ์</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + webConNews.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      @change="searchData"
                      v-model="search_data.news_stratrgic_tag"
                      :items="stratrgic_combo"
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ยุทธศาสตร์"
                      clearable=""
                  ></v-select>


                </v-col>


               

                <v-col class="d-flex" cols="12" sm="4">

                  <v-select
                      @change="searchData"
                      v-model="search_data.news_type_tag"
                      :items="new_type_combo_ALL"
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ส่วนแสดงผล"
                      clearable=""

                  ></v-select>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                  <v-text-field
                      append-icon="mdi-magnify"
                      class="search"
                      v-model="search"
                      label="ค้นหา (Search)"
                  ></v-text-field>
                </v-col>

              </v-row>



<!--              <v-text-field-->
<!--                  v-model="search"-->
<!--                  append-icon="mdi-magnify"-->
<!--                  label="ค้นหา (Search)"-->
<!--                  single-line-->
<!--                  hide-details-->
<!--                  class="search"-->
<!--              ></v-text-field>-->
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :options="options"
                :items="webConNews"
                :search="search"
                sort-by="news_id">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>

              <template v-slot:item.news_h_image_th="{ item }">

                <v-avatar tile>
                  <img
                      :src="baseURLStorage+item.news_h_image_th"
                      :alt="item.news_title_th"
                  >
                </v-avatar>
                <v-avatar tile v-if="item.switch_lang=='Y'">
                  <img
                      :src="baseURLStorage+item.news_h_image_en"
                      :alt="item.news_title_th"
                  >
                </v-avatar>


              </template>


              <template v-slot:item.switch_lang="{ item }">
                <v-btn
                    fab
                    x-small
                    depressed
                    color=""
                >TH
                </v-btn>
                <v-btn v-if="item.switch_lang=='Y'"
                       fab
                       x-small
                       depressed
                       color=""
                >EN
                </v-btn>

              </template>


              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>

                <v-btn
                    @click="viewAlbum(item)"
                    small
                    class="mr-3 button-shadow"
                    color="warning"
                >อัลบั้ม
                </v-btn>


                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">
                  <v-text-field
                      v-model="editForm.order_seq"
                      label="ลำดับ"
                      required
                      disabled
                      v-if="state=='addForm'"
                  ></v-text-field>

                  <v-text-field
                      v-model="editForm.order_seq"
                      :rules="editForm.textReqRules.concat(editForm.orderRules)"
                      label="ลำดับ"
                      required
                      v-else
                  ></v-text-field>

                </v-col>

                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      @change="changeSwitchCal()"
                      v-model="editForm.switch_calendar"
                      inset
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ปฏิทินกิจกรรม"
                      required
                  ></v-switch>


                </v-col>


                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.switch_lang"
                      inset
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="เพิ่มเนื้อหาภาษา [EN]"
                      required
                  ></v-switch>


                </v-col>


                <v-col class="d-flex" cols="12" sm="6">

                  <v-select
                      v-model="editForm.news_stratrgic_tag"
                      :items="stratrgic_combo"
                      attach
                      chips
                      deletable-chips
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ยุทธศาสตร์"
                      multiple
                  ></v-select>

                </v-col>

              </v-row>

              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="6">

                  <v-select
                      v-model="editForm.news_type_tag"
                      :rules="editForm.textReqRules"
                      :items="new_type_combo"
                      attach
                      chips
                      deletable-chips
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ส่วนแสดงผล"
                      multiple
                      required
                  ></v-select>


                </v-col>

                <v-col class="d-flex" cols="12" sm="6">


                  <v-combobox
                      v-model="editForm.news_tag"
                      chips
                      clearable
                      label="เพิ่ม Tag/Keywords สามารถเลือกจากรายการ /หรือพิมพ์แล้วกด Enter"
                      multiple

                  >
                    <template v-slot:selection="{ attrs, item, select, selected }">
                      <v-chip
                          v-bind="attrs"
                          :input-value="selected"
                          close
                          @click="select"
                          @click:close="removeTag(item)"
                      >
                        <strong>{{ item }}</strong>
                      </v-chip>
                    </template>
                  </v-combobox>

                </v-col>
              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='addForm'">

                  <v-col v-if="editForm.preview==''">

                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                      <v-col
                          class="text-subtitle-1 text-center"
                          cols="12"
                      >
                        เลือกไฟล์เพื่อแสดงผล
                      </v-col>
                      <v-col cols="6">
                        <v-progress-linear
                            color="deep-purple accent-4"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                      </v-col>
                    </v-row>

                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='addForm'">

                  <v-file-input
                      @change="previewImage"
                      v-model="editForm.avatarFile"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.imageRules)"
                      accept="image/*"
                      placeholder="ภาพประกอบหัวข้อ (TH)"
                      prepend-icon="mdi-file-image"
                      label="ภาพประกอบหัวข้อ (TH) "
                  ></v-file-input>


                </v-col>

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='addForm' && editForm.switch_lang=='Y'">

                  <v-col v-if="editForm.preview_en==''">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                      <v-col
                          class="text-subtitle-1 text-center"
                          cols="12"
                      >
                        เลือกไฟล์เพื่อแสดงผล
                      </v-col>
                      <v-col cols="6">
                        <v-progress-linear
                            color="deep-purple accent-4"
                            indeterminate
                            rounded
                            height="6"
                        ></v-progress-linear>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview_en" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='addForm' && editForm.switch_lang=='Y'">

                  <v-file-input
                      @change="previewImageEn"
                      v-model="editForm.avatarFileEn"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.imageRules)"
                      accept="image/*"
                      placeholder="ภาพประกอบหัวข้อ (EN)"
                      prepend-icon="mdi-file-image-plus"
                      label="ภาพประกอบหัวข้อ (EN) "
                  ></v-file-input>


                </v-col>


                <!--*************************************************-->

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='editForm'">

                  <v-col v-if="editForm.preview==''">

                    <v-img
                        :src="baseURLStorage+editForm.avatarFileOld"
                        :alt="editForm.news_title_th"
                        style="max-width: 100%"
                    ></v-img>

                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='editForm'">

                  <v-file-input
                      @change="previewImage"
                      v-model="editForm.avatarFile"
                      show-size
                      chips
                      :rules="editForm.imageRules"
                      accept="image/*"
                      placeholder="ภาพประกอบหัวข้อใหม่ (TH)"
                      prepend-icon="mdi-file-image"
                      label="ภาพประกอบหัวข้อใหม่ (TH) "
                  ></v-file-input>


                </v-col>

                <v-col class="d-flex" cols="12" sm="2" v-if="state=='editForm' && editForm.switch_lang=='Y'">

                  <v-col v-if="editForm.preview_en==''">
                    <v-img
                        :src="baseURLStorage+editForm.avatarFileEnOld"
                        :alt="editForm.news_title_en"
                        style="max-width: 100%"
                    ></v-img>
                  </v-col>
                  <v-col v-else>
                    <img v-bind:src="editForm.preview_en" style="max-width: 100%"/>
                  </v-col>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='editForm' && editForm.switch_lang=='Y'">

                  <v-file-input
                      @change="previewImageEn"
                      v-model="editForm.avatarFileEn"
                      show-size
                      chips
                      :rules="editForm.imageRules"
                      accept="image/*"
                      placeholder="ภาพประกอบหัวข้อใหม่ (EN)"
                      prepend-icon="mdi-file-image-plus"
                      label="ภาพประกอบหัวข้อใหม่ (EN) "
                  ></v-file-input>


                </v-col>

                <!--*************************************************-->

                <v-col class="d-flex" cols="12" v-bind:sm="editForm.switch_lang=='Y'?12:6">


                  <v-combobox
                      v-model="editForm.news_sdgs_full"
                      :items="sdgs_combo"
                      item-text="v_name"
                      item-value="v_value"
                      chips
                      clearable
                      label="SDGs"
                      multiple
                  >
                    <template v-slot:selection="{ attrs, item, select, selected }">
                      <v-chip
                          v-bind="attrs"
                          :input-value="selected"
                          close
                          @click="select"
                          @click:close="removeSdgs(item)"
                      >
                        <v-avatar>
                          <img
                              :src="item.v_img"
                              alt=""
                          >
                        </v-avatar>
                        <strong>{{ item.v_value }}</strong>
                      </v-chip>
                    </template>
                  </v-combobox>


                </v-col>


              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.news_title_th"
                      :rules="editForm.textReqRules"
                      label="หัวข้อข่าว/ชื่อเรื่อง (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" v-if="editForm.switch_lang=='Y'">
                  <v-text-field
                      v-model="editForm.news_title_en"
                      :rules="editForm.textReqRules"
                      label="หัวข้อข่าว/ชื่อเรื่อง (EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>


              <v-row align="center" v-if="editForm.switch_calendar=='Y'">

                <v-col class="d-flex" cols="12" sm="4" >
                  <v-text-field
                      v-model="editForm.news_c"
                      :rules="editForm.textReqRules"
                      label="วันที่ (TH) เช่น 30 มิ.ย. 2566"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                  <v-text-field
                      v-model="editForm.news_a"
                      :rules="editForm.textReqRules"
                      label="ชื่อหลัก/บุคคล/สถานที่ (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4" >
                  <v-text-field
                      v-model="editForm.news_b"
                      :rules="editForm.textReqRules"
                      label="ตำแหน่ง/สถานที่ (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" >
                  <v-text-field
                      v-model="editForm.news_d"
                      :rules="editForm.textReqRules"
                      label="คำอธิบายโดยย่อ (TH)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>

              <v-row align="center" v-if="editForm.switch_calendar=='Y' && editForm.switch_lang=='Y'">

                <v-col class="d-flex" cols="12" sm="4" >
                  <v-text-field
                      v-model="editForm.news_g"
                      :rules="editForm.textReqRules"
                      label="วันที่ (EN) เช่น 30 มิ.ย. 2023"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4">
                  <v-text-field
                      v-model="editForm.news_e"
                      :rules="editForm.textReqRules"
                      label="ชื่อหลัก/บุคคล/สถานที่ (EN)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="4" >
                  <v-text-field
                      v-model="editForm.news_f"
                      :rules="editForm.textReqRules"
                      label="ตำแหน่ง/สถานที่ (EN)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" >
                  <v-text-field
                      v-model="editForm.news_h"
                      :rules="editForm.textReqRules"
                      label="คำอธิบายโดยย่อ (EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>



              <v-row align="center">

                <v-col>

                  <v-chip

                      color="success"
                      class="ma-2"
                  >
                    ข่าวประชาสัมพันธ์ (TH)
                  </v-chip>
                  <v-chip
                      @click="showUploads"
                      color="info"
                      class="ma-2"
                  >
                    <v-icon left>
                      mdi-cloud-upload
                    </v-icon>

                    อัพโหลดไฟล์/รูป ประกอบเนื้อหา
                  </v-chip>

                  <editor
                      id="news_content_th"
                      v-model="editForm.news_content_th"
                      :api-key=tiny.api
                      :init="{
                       convert_urls:true,
                       relative_urls:false,
                       remove_script_host:false,
                       // images_upload_url: baseURLApi+'/uploads_tinymce',
                       height: 500,
                       menubar: true,
                       plugins: tiny.plugins,
                       toolbar: tiny.toolbar,
                       valid_elements : '*[*]', //tag css other
                       forced_root_block : false //remove tag p
                      }"
                  />


                </v-col>


              </v-row>

              <v-row align="center" v-if="editForm.switch_lang=='Y'">

                <v-col>

                  <v-chip

                      color="secondary"
                      class="ma-2"
                  >
                    ข่าวประชาสัมพันธ์ (EN)
                  </v-chip>

                  <v-chip
                      @click="showUploads"
                      color="info"
                      class="ma-2"
                  >
                    <v-icon left>
                      mdi-cloud-upload
                    </v-icon>

                    อัพโหลดไฟล์/รูป ประกอบเนื้อหา
                  </v-chip>

                  <editor
                      id="news_content_en"
                      v-model="editForm.news_content_en"
                      :api-key=tiny.api
                      :init="{
                       convert_urls:true,
                       relative_urls:false,
                       remove_script_host:false,
           height: 500,
           menubar: true,
           plugins: tiny.plugins,
           toolbar: tiny.toolbar,
           valid_elements : '*[*]', //tag css other
           forced_root_block : false //remove tag p

          }"
                  />
                </v-col>

              </v-row>


              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="4">

                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>

                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>

      <v-col cols="12">

        <v-card class="mb-1" v-if="state=='view-album'">

          <ConNewImageManagement
              id="User_ConNewImageManagement">

          </ConNewImageManagement>


          <v-alert
              border="top"
              colored-border
              color="success"
              elevation="2"
          >

            <v-row align="center">
              <v-col class="grow">
                <v-avatar>
                  <img
                      :src="baseURLStorage+temp_data.news_h_image_th"
                      :alt="temp_data.news_title_th"
                  >
                </v-avatar>

                หัวข้อข่าว/ชื่อเรื่อง <strong>{{ temp_data.news_title_th }}</strong>
              </v-col>
              <v-col class="shrink">
                <v-btn
                    color="primary"
                    outlined
                    class="button-shadow mr-4"
                    @click="close">
                  กลับสู่หน้าหลัก
                </v-btn>
              </v-col>
            </v-row>


          </v-alert>


        </v-card>



      </v-col>



    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import Editor from '@tinymce/tinymce-vue';

import UploadManagement from '@/pages/WebContent/UploadManagement/UploadManagement';
import axios from "axios";
import ConNewImageManagement from '@/pages/WebContent/ConNewImageManagement/ConNewImageManagement';

export default {
  name: 'ConNewManagement',
  data() {
    return {
      state: 'index',
      tiny: config.tiny,
      baseURLApi: config.baseURLApi,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      dialog_upload: false,
      search: '',
      search_data:{
        news_stratrgic_tag: "",
        news_type_tag: "",
      },
      selected: [],
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          value: 'order_seq',
        },
        {
          text: 'ภาพหัวข้อ',
          value: 'news_h_image_th',
        },
        {text: 'หลายภาษา', value: 'switch_lang'},
        {text: 'หัวข้อข่าว/ชื่อเรื่อง', value: 'news_title_th'},

        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],
      options: {
        sortBy: ["order_seq"],
        sortDesc: [true]
      },
      stratrgic_combo: [],
      new_type_combo: [],
      new_type_combo_ALL: [],
      new_type_combo_PR: [],
      new_type_combo_CAL: [],
      sdgs_combo: [
        {
          v_value: 'SDGs1',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs1.png',
          v_name: '1.ขจัดความยากจนทกุรูปแบบในทุกพื้นที่'
        },
        {
          v_value: 'SDGs2',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs2.png',
          v_name: '2.ยุติความหิวโหย บรรลุความมั่นคงทางอาหารและยกระดับโภชนาการและส่งเสริมเกษตรกรรมที่ยั่งยืน'
        },
        {
          v_value: 'SDGs3',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs3.png',
          v_name: '3.สร้างหลักประกันว่าคนมีชีวิตที่มีสุขภาพดีและส่งเสริมความเป็นอยู่ที่ดีสำหรับทุกคนในทุกวัย'
        },
        {
          v_value: 'SDGs4',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs4.png',
          v_name: '4.สร้างหลักประกันว่าทุกคนมีการศึกษาที่มีคุณภาพอย่างครอบคลุมและเท่าเทียม และสนับสนุนโอกาสในการเรียนรู้ตลอดชีวิต '
        },
        {
          v_value: 'SDGs5',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs5.png',
          v_name: '5.บรรลุความเท่าเทียมระหว่างเพศ และเสริมอำนาจให้แก่สตรีและเด็กหญิง '
        },
        {
          v_value: 'SDGs6',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs6.png',
          v_name: '6.สร้างหลักประกันว่าจะมีการจัดให้มีน้ำและสุขอนามัยสำหรับทุกคนและมีการบริหารจัดการที่ยั่งยืนคน'
        },
        {
          v_value: 'SDGs7',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs7.png',
          v_name: '7.สร้างหลักประกันให้ทุกคนสามารถเข้าถึงพลังงานสมัยใหม่ที่ยั่งยืนในราคาที่ย่อมเยา'
        },
        {
          v_value: 'SDGs8',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs8.png',
          v_name: '8.ส่งเสริมการเติบโตทางเศรษฐกิจที่ต่อเนื่อง ครอบคลุม และยั่งยืน การจ้างงานเต็มที่ มีผลิตภาพ และการมีงานที่เหมาะสมสำหรับทุกคน'
        },
        {
          v_value: 'SDGs9',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs9.png',
          v_name: '9.สร้างโครงสร้างพื้นฐานที่มีความทนทาน ส่งเสริมการพัฒนาอุตสาหกรรมที่ครอบคลุมและยั่งยืน และส่งเสริมนวัตกรรม'
        },
        {
          v_value: 'SDGs10',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs10.png',
          v_name: '10.ลดความไม่เสมอภาคภายในประเทศและระหว่างประเทศ'
        },
        {
          v_value: 'SDGs11',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs11.png',
          v_name: '11.ทำให้เมืองและการตั้งถิ่นฐานของมนุษย์มีความครอบคลุม ปลอดภัย มีภูมิต้านทานและยั่งยืน '
        },
        {
          v_value: 'SDGs12',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs12.png',
          v_name: '12.สร้างหลักประกันให้มีรูปแบบการผลิตและการบริโภคที่ยั่งยืน'
        },
        {
          v_value: 'SDGs13',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs13.png',
          v_name: '13.ปฏิบัติการอย่างเร่งด่วนเพื่อต่อสู้การเปลี่ยนแปลงสภาพภูมิอากาศและผลกระทบที่เกิดขึ้น'
        },
        {
          v_value: 'SDGs14',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs14.png',
          v_name: '14.อนุรักษ์และใช้ประโยชน์จากมหาสมุทร ทะเล และทรัพยากรทางทะเลอย่างยั่งยืนเพื่อการพัฒนาที่ยั่งยืน'
        },
        {
          v_value: 'SDGs15',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs15.png',
          v_name: '15.ปกป้อง ฟื้นฟู และสนับสนุนการใช้ระบบนิเวศบนบกอย่างยั่งยืน จัดการป่าไม้อย่างยั่งยืนต่อสู้การกลายสภาพเป็นทะเลทราย หยุดการเสื่อมโทรมของที่ดินและฟื้นสภาพดิน และหยุดยั้งการสูญเสียความหลากหลายทางชีวภาพ'
        },
        {
          v_value: 'SDGs16',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs16.png',
          v_name: '16.ส่งเสริมสังคมที่สงบสุขและครอบคลุมเพื่อการพัฒนาที่ยั่งยืน ให้ทุกคนเข้าถึงความยุติธรรม และสร้างสถาบันที่มีประสิทธิภาพ รับผิดชอบ และครอบคลุมในทุกระดับ'
        },
        {
          v_value: 'SDGs17',
          v_img: config.baseURLStorage+'/icon_sdgs/SDGs17.png',
          v_name: '17.เสริมความเข้มแข็งให้แก่กลไกการดำเนินงานและฟื้นฟูหุ้นส่วนความร่วมมือระดับโลกเพื่อการพัฒนาที่ยั่งยืน'
        },
      ],
      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {},
      temp_data: null,
    }
  },
  components: {
    'editor': Editor, // <- Important part
    UploadManagement,
    ConNewImageManagement
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_news', ['webConNews', "isReceiving", "isDeleting", "idToDelete", "webConNewMessage", "isUpdating", "errorMessage"]),

    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    webConNewMessage() {

      if (this.webConNewMessage !== '') {
        this.notification = this.webConNewMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getWebConNewsRequest(this.search_data);
    this.getDcParamCombobox();
    this.resetValue();
  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_news',
        [
          "getWebConNewsRequest",
          "deleteWebConNewRequest",
          "updateWebConNewRequest",
          "createWebConNewRequest"
        ]
    ),
    ...mapActions('web_con_new_images', ["getWeb_con_new_imagesRequest" ]),

    resetValue(){
      this.editForm = {} //set null all value
      this.editForm = {
        valid: true,
        orderRules: validateRules.orderRules,
        textReqRules: validateRules.textReqRules,
        imageRules: validateRules.fileSingleRules(3),
        news_id: null,
        news_type_tag: '',
        news_stratrgic_tag: [],
        news_tag: [],
        news_sdgs: [],
        new_start_date: null,
        news_sdgs_full: [],
        news_title_th: '',
        news_title_en: '',
        news_content_th: '',
        news_content_en: '',
        switch_lang: 'N',
        switch_calendar: 'N',
        active: 'N',
        news_a: '',
        news_b: '',
        news_c: '',
        news_d: '',
        news_e: '',
        news_f: '',
        news_g: '',
        news_h: '',
        preview: '',
        preview_en: '',
        avatarFile: null,
        avatarFileOld: null,
        avatarFileEn: null,
        avatarFileEnOld: null,
        news_h_image_en: null,
        news_h_image_th: null
      }
    },
    async getDcParamCombobox() {

      try {

        await axios.post(config.baseURLApi + '/combo_dc_param/' + 'WEB' + '/' + 'NEWS_STRATRGIC', '', {
          headers: {},
        }).then(res => {
          this.stratrgic_combo = res.data;
        });

        await axios.post(config.baseURLApi + '/combo_dc_param/' + 'WEB' + '/' + 'NEWS_TYPE', '', {
          headers: {},
        }).then(res => {
          this.new_type_combo = res.data;
          this.new_type_combo_PR = res.data;

           axios.post(config.baseURLApi + '/combo_dc_param/' + 'WEB' + '/' + 'NEWS_TYPE_CAL', '', {
            headers: {},
          }).then(res2 => {


            this.new_type_combo_CAL = res2.data;
            this.new_type_combo_ALL = res.data.concat(res2.data);
          });

        });




      } catch (e) {
        this.showSnackbar(e);
      }


    },
    removeTag(item) {

      this.editForm.news_tag.splice(this.editForm.news_tag.indexOf(item), 1)
    },
    removeSdgs(item) {

      this.editForm.news_sdgs_full.splice(this.editForm.news_sdgs_full.indexOf(item), 1)
    },
    addSdgs(item) {

      var arrSDGs = item.split(",");
      console.log(arrSDGs)
      var arr = [];
      for (var i = 0; i < arrSDGs.length; i++) {
        arr.push(this.sdgs_combo.find(item => item.v_value === arrSDGs[i]));
      }
      return arr;

    },
    previewImage: function (event) {
      event == null ? this.editForm.preview = '' : this.editForm.preview = URL.createObjectURL(event)
    },
    previewImageEn: function (event) {
      event == null ? this.editForm.preview_en = '' : this.editForm.preview_en = URL.createObjectURL(event)
    },
    changeSwitchCal() {
      this.editForm.news_type_tag='';
      var new_type_combo = null;
      new_type_combo = this.editForm.switch_calendar == 'N' ? this.new_type_combo_PR : this.new_type_combo_CAL;
      this.new_type_combo = new_type_combo;
    },
    addItem() {

      this.editedIndex = -1 //index = -1 add
      this.resetValue();
      this.editForm.active='Y';
      this.editForm.order_seq='AUTO'
      this.editForm.news_content_th='กรอกรายละเอียดที่นี่.....'
      this.state = 'addForm';

    },
    editItem(item) {
      this.resetValue();
      this.editedIndex = this.webConNews.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.news_id = item.news_id;
      this.editForm.news_stratrgic_tag = !item.news_stratrgic_tag != true ? item.news_stratrgic_tag.split(",") : [];
      this.editForm.news_type_tag = !item.news_type_tag != true ? item.news_type_tag.split(",") : [];
      this.editForm.avatarFileOld = item.news_h_image_th;
      this.editForm.avatarFileEnOld = item.news_h_image_en;

      this.editForm.news_title_th = item.news_title_th;
      this.editForm.news_title_en = item.news_title_en;
      this.editForm.news_content_th = item.news_content_th;
      this.editForm.news_content_en = item.news_content_en;
      this.editForm.news_tag = !item.news_tag != true ? item.news_tag.split(",") : [];
      this.editForm.news_sdgs_full = !item.news_sdgs != true ? this.addSdgs(item.news_sdgs) : [];
      // this.editForm.new_start_date = item.new_start_date;
      this.editForm.order_seq = item.order_seq * 1;
      this.editForm.switch_lang = item.switch_lang;
      this.editForm.switch_calendar = item.switch_calendar;
      this.editForm.active = item.active;
      this.editForm.news_a = item.news_a;
      this.editForm.news_b = item.news_b;
      this.editForm.news_c = item.news_c;
      this.editForm.news_d = item.news_d;
      this.editForm.news_e = item.news_e;
      this.editForm.news_f = item.news_f;
      this.editForm.news_g = item.news_g;
      this.editForm.news_h = item.news_h;
      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWebConNewRequest({news_id: item.news_id})

    },
    viewAlbum(item) {
      this.temp_data = null;
      this.temp_data = item;
      this.getWeb_con_new_imagesRequest({
        news_id: item.news_id
      });
      this.state = "view-album";
    },
    close() {

      if (this.errorMessage == false || this.webConNewMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {
      this.editForm.news_sdgs = [];
      for (const element of this.editForm.news_sdgs_full) { // You can use `let` instead of `const` if you like
        this.editForm.news_sdgs.push(element.v_value)
      }

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.webConNews[this.editedIndex], this.editForm)
            :
            this.updateWebConNewRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.webConNews.push(this.editForm)
            :
            this.createWebConNewRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    async reset() {
      await  this.$refs.form.reset()
      this.resetValue()
    },
    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    showUploads() {
      this.dialog_upload = true;
    },
    searchData(){
      this.getWebConNewsRequest(this.search_data);
    },
    async beforeMount() {
    },

  },
}
</script>

<style src="./ConNewManagement.scss" lang="scss"/>
